import React from 'react';
import ReactDOM from 'react-dom';
import '../slider/juxtapose';

import core from '~/core/scripts';
import WaveViz from './WaveViz';
import BarChartViz from './BarChartViz';
import IconViz from './IconViz';
import './lazyjuxt';

import './index.styl';

if (module.hot) {
  // we only want HMR enabled for stylus files
  module.hot.accept(/\.styl$/);
}

core.init();

const BarVizVerfranzen = (
  <BarChartViz
    title="Während des Kriegs produzierte Kriegsflugzeuge"
    overallCount={219799}
    icon="aircraft"
    data={[
      { name: 'Großbritanien', value: 67987 },
      { name: 'Frankreich', value: 58144 },
      { name: 'Deutschland', value: 48537 },
      { name: 'Italien', value: 20000 },
      { name: 'USA', value: 15000 },
      { name: 'Österreich', value: 5431 },
      { name: 'Russland', value: 4700 }
    ]}
    className="verfranzen-viz"
  />
);
const BarViz0815 = (
  <BarChartViz
    title="Während des Kriegs gefallene Soldaten"
    overallCount={10201600}
    showOverallCountBar={false}
    showOverallCountTitle={true}
    icon="cemetery"
    data={[
      { name: 'Deutsches Reich', value: 2037000 },
      { name: 'Russisches Kaiserreich', value: 1997500 },
      { name: 'Österreich-Ungarn', value: 1513500 },
      { name: 'Frankreich', value: 1327000,
        sub: { name: 'französische Kolonien', value: 78000 }
      },
      { name: 'Osmanisches Reich', value: 772000 },
      { name: 'Großbritannien', value: 761000,
            sub: { name: 'übriges britisches Weltreich', value: 198000 }
      },
      { name: 'Italien', value: 600000 },
      { name: 'Serbien', value: 278000 },
      { name: 'Rumänien', value: 250700 },
      { name: 'Vereinigte Staaten', value: 87900 },
      { name: 'Bulgarien', value: 87500 },
      { name: 'Kanada *', value: 61000 },
      { name: 'Australien *', value: 60000 },
      { name: 'Indien *', value: 54000 },
      { name: 'Belgien', value: 38000 },
      { name: 'Griechenland', value: 26000 },
      { name: 'Neuseeland *', value: 16000 },
      { name: 'Portugal', value: 7200 },
      { name: 'Südafrika *', value: 7000 },
      { name: 'Montenegro', value: 3000 },
      { name: 'Japan', value: 300 }
    ]}
    className="0815-viz"
  />
);

const IconVizCakes = (
  <IconViz
    title="Tägliche Kalorienzufuhr pro Kopf im Deutschen Reich"
    legendText="gemessen in Hartkeksen (Bundeswehr), 1 Stk. ca 40 kcal"
    icon="hartkeks"
    sections={[
      { title: '1914', subtitle: 'Vor dem Krieg', count: 85, kcal: 3400 },
      { title: '1917', subtitle: 'Während des Krieges', count: 25, kcal: 1000 },
      { title: 'Unterernährung', subtitle: 'Schwellenwert heute*', count: 45, kcal: 1800 },
    ]}
    sourceText="*laut UN-Ernährungsorganisation FAO"
  />
);

ReactDOM.render(<WaveViz audioSrc="data/wummern.mp3" />, document.getElementById('waveviz-1'));
ReactDOM.render(<WaveViz audioSrc="data/trommelfeuer.mp3" />, document.getElementById('waveviz-2'));
ReactDOM.render(BarVizVerfranzen, document.getElementById('verfranzen-viz'));
ReactDOM.render(IconVizCakes, document.getElementById('keks-viz'));
ReactDOM.render(BarViz0815, document.getElementById('0815-viz'));

// this is just for development purposes -> if we are looking at a layout-sample,
// we check if there is a corresponding js file
if (process.env.NODE_ENV === 'development') {
  // enable livereload for index html
  require('file-loader!./index.html');

  if (location.pathname.includes('.html')) {
    const fileToLoad = location.pathname.replace('.html', '.js');
    try {
      require(`./layout-samples${fileToLoad}`);
    } catch(e) {
      console.log(`[Starterkit] no file found ${fileToLoad}`);
    }
  }
}